// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
    //TODO: write your page related code here...

});

export function countdownClock1_viewportEnter(event) {
    //Add your code for this event here: 
}

export function header1_viewportEnter(event) {
    //Add your code for this event here: 
}

export function html11_mouseOut(event) {
    //Add your code for this event here: 
}